import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Chip } from '@mui/material';

type SupplierServiceChipsProps = {
    services: string[];
    /** DD-3696: the translation key of a service, which differs per directory. */
    labelKey: (service: string) => string;
};

const SupplierServiceChips: FC<SupplierServiceChipsProps> = ({ services, labelKey }) => {
    const { t: translate } = useTranslation(['lab-settings']);
    if (!services.length) return null;
    return (
        <Box display="flex" flexWrap="wrap" gap={0.5}>
            {services.map((service) => (
                <Chip key={service} size="small" variant="outlined" label={translate(labelKey(service))} />
            ))}
        </Box>
    );
};

export default SupplierServiceChips;
